var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecrement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11.042,
    height: 10.031,
    fill: "none",
    viewBox: "0 0 11.042 10.031",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.7934 9.0385c0.77176 1.323 2.6834 1.323 3.4551 0l3.5179-6.0307c0.7778-1.3333-0.184-3.0077-1.7276-3.0077h-7.0359c-1.5436 0-2.5053 1.6744-1.7276 3.0077z",
    fill: "#cc214f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecrement);
export default __webpack_public_path__ + "static/media/decrement.7697c624490e7ce52b8b07fcd0d7c717.svg";
export { ForwardRef as ReactComponent };